import { AccordionGroup } from "@frends/ui-components/react";

export default AccordionGroup;
